import { useState } from 'react';
import { useGetItem } from 'Features/HTTP/RequestHandlers';
import { useResponseHandler, useErrorHandler } from 'Features/HTTP/ResponseHandler';
import { useTranslation } from 'react-i18next';
import apiConfig from 'Application/configurations/apiConfig';
import IReadTransferFreightCost from './IReadTransferFreightCost';
import { useAccessTokens } from 'Features/Authentication';

const useGetTransferFreightCost = () => {

    const { t } = useTranslation();
    const getItem = useGetItem();
    const responseHandler = useResponseHandler();
    const errorHandler = useErrorHandler();
    const [ transferFreightCost, setTransferFreightCost ] = useState<IReadTransferFreightCost>({id: "", companyId: "", name: "", isAnswered: false, isPermanentlyLocked: false, freightCosts: [{id: 0, companyId: "", companyName: "", companyArea: "", freightCost: null}],openDate: new Date(), closeDate: new Date()});
    const getToken = useAccessTokens();
    const AccessAsUser = apiConfig.scopes.AccessAsUser;

    /** Read transfer freight cost by guid
     * @param {string} companyId - guid of the company
     * @param {string} surveyId - guid of the survey
     * @returns {object} transferFreightCost - transferFreightCost object
     **/
    const getTransferFreightCostById = async (companyId: any, surveyId: any) => {

        const basePath = apiConfig.basePath;
        const companyEndpoint = apiConfig.endpoints.companies
        const surveyEndpoint = apiConfig.endpoints.transferFreightCosts;
        const url = new URL(`${basePath}/${companyEndpoint}/${companyId}/${surveyEndpoint}/${surveyId}`);
        const accessToken = await getToken([AccessAsUser]);

        const options = {
            accessToken: accessToken
        }

        try {

            const response = await getItem(url, options);
            const data = response?.data || [];
            setTransferFreightCost(data);
            return responseHandler(response, "useGetTransferFreightCost", { operation: "read", hide: true });

        } catch (error: any) {

            let problemTitle = error && error.data && error.data.title ? error.data.title : "";
            let body = null;

            if (problemTitle === "TransferFreightCost.ReadPermissionDenied") body = t('features.survey.readPermissionDenied');
            if (problemTitle === "Company.CompanyDataAccessDenied") body = t('features.company.companyDataAccessDenied');
            if (problemTitle === "Company.NotExist") body = t('features.company.notExist');
            if (problemTitle === "UserAccount.NotExist") body = t('features.account.userAccountNotExist');
            if (problemTitle === "General.RequestorNotExist") body = t('features.survey.requestorNotExist');
            if (problemTitle === "TransferFreightCost.NotExist") body = t('features.survey.notExist');

            return errorHandler(error, "useGetTransferFreightCost", { operation: "read", hide: false, messageBody: body });

        }

    }

    return { transferFreightCost, setTransferFreightCost, getTransferFreightCostById };

}

export default useGetTransferFreightCost;
